// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"1da4c890","281":"84e6deb6","290":"821c5eb7","609":"29e058da","691":"73c01b1d","722":"bded2af6","758":"0e7343ac","772":"7e9ad137"}[chunkId] + ".chunk.js";
};